import * as React from 'react'
import { theme } from '../theme'
import { EraserIcon } from '../icons'
import { BrushSizeControl } from './BrushSizeControl'
import { ActionButtons } from '../editor/ActionButtons'

type TDrawingTool = 'brush' | 'eraser' | null

interface Props {
	currentTool: TDrawingTool
	isEditing: boolean
	onToolSelect: (tool: TDrawingTool) => void
	hasMask: boolean
	onUndo: () => void
	onAccept: () => void
	brushSize: number
	onBrushSizeChange: (size: number) => void
}

export const EraseTools = ({
	currentTool,
	isEditing,
	onToolSelect,
	hasMask,
	onUndo,
	onAccept,
	brushSize,
	onBrushSizeChange,
}: Props) => {
	const toolButtonStyle = {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '32px',
		height: '32px',
		cursor: 'pointer',
		transition: 'all 0.2s ease',
		padding: theme.spacing.xs,
	}

	return (
		<div style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing.md, width: '100%' }}>
			{/* Tool Title */}
			<h3
				style={{
					margin: 0,
					marginBottom: theme.spacing.sm,
					fontSize: theme.typography.sizes.sm,
					color: theme.colors.text.primary,
					fontWeight: 500,
					paddingBottom: theme.spacing.sm,
					borderBottom: `1px solid ${theme.colors.border}`,
				}}
			>
				Remove Content from Image
			</h3>

			{/* Instructions */}
			<div style={{ color: theme.colors.text.muted, fontSize: '14px' }}>
				Adjust the brush size and paint the area you want to remove from the image.
			</div>

			{/* Brush Size Control Container */}
			<div style={{ width: '100%' }}>
				<BrushSizeControl brushSize={brushSize} onBrushSizeChange={onBrushSizeChange} />
			</div>

			{/* Tool Controls Row */}
			<div style={{ display: 'flex', alignItems: 'center', gap: theme.spacing.md }}>
				{/* Eraser Tool Button */}
				<div
					style={{
						...toolButtonStyle,
						backgroundColor: currentTool === 'eraser' ? 'rgba(47, 123, 118, 0.1)' : 'transparent',
					}}
					onClick={() => onToolSelect('eraser')}
					title="Eraser"
				>
					<EraserIcon
						size={16}
						color={isEditing && currentTool === 'eraser' ? theme.colors.primary : theme.colors.text.muted}
					/>
				</div>

				{/* Action Buttons */}
				<ActionButtons
					isReturnDisabled={!hasMask}
					isAcceptDisabled={!hasMask}
					onReturn={onUndo}
					onAccept={onAccept}
					variant="compact"
					acceptLabel="Remove Content"
				/>
			</div>
		</div>
	)
}
